// extracted by mini-css-extract-plugin
export var sbShowMain = "author-module--sb-show-main--2RX2y";
export var wrapper = "author-module--wrapper--1TROf";
export var imageWrapper = "author-module--imageWrapper--2kxds";
export var image = "author-module--image--V0mz8";
export var note = "author-module--note--3sNqe";
export var name = "author-module--name--2RqRF";
export var position = "author-module--position--2P6sK";
export var bio = "author-module--bio--3mc9I";
export var textWrapper = "author-module--textWrapper--14ur1";